export default ({...props}) => {
  const {palette, primaryButton, size} = props.theme
  return `
  height: ${size(7)}px;
  min-width: 100%;
  max-width:${size(100)}px;
  margin-bottom: ${size(0.625)}px;
  padding: ${size(0)}px;
  .MuiFormControlLabel-root {
    margin: ${size(1)}px;
    width: 100%;
    height:100%;
    margin-right:${size(0)}px;
    margin-left: 0px;
    padding-left:${size(2)}px;
    .MuiTypography-root {
      width: 100%;
    }
  }
  [ap_atom_name="svgIconAtom"]{
    width: ${size(2.25)}px;
    height:${size(2.375)}px;
    display: -webkit-box;
    &[ap_type="greenLeaf"]
    {
      width:${size(3)}px;
      height:${size(1.5)}px;
    }
    > svg {
      width: ${size(12.5)}%;
    }
  }
  [ap_type="cardCheckSelected"]{
    path {
      fill: ${palette.common.white};
    }
  }
  &[ap_type="secondary"]{
    background-color: ${palette.common.white};
    border-color: ${palette.text.disabled};
    &:hover{
      background-color:${primaryButton.background}20;
    }
  }
  .MuiTypography-body1{
    margin-bottom: ${size(0)}px;
  }

  [ap_atom_name="stackAtom"]{
    width: 100%;
    justify-content: space-between;
    padding-right:${size(3)}px;
    & > div{
     padding: ${size(0)}px;
      padding-left:${size(1)}px;
    }
  }
  `
}
